import styles from './gst.module.scss';
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from 'react';
import GstDetails from '../../../Underwriting/CompanyDetails/GstDetails/GstDetails';
import { MonthlyReportFormContext } from '../../context/MonthlyReportFormContext';
import arrayMutators from 'final-form-arrays';
import { Field, Form, FormSpy, useForm } from 'react-final-form';
import { findFirstErrorField, setFieldTouchedMutator } from '../../../../components/functions/utilities';
import { validateGstDetails } from '../../../Underwriting/CompanyDetails/companyDetailsHelper';
import { ApplicationContextType, MonthlyReportSteps } from '../../../../interfaces/interfaces';
import { useSearchParams } from 'react-router-dom';

type Props = {
  setFormPristine: (value: boolean) => void,
  formType: ApplicationContextType
}

const GST = forwardRef(({ setFormPristine, formType }: Props, ref) => {
  const {
    formData,
    formCompleteStatus,
    underwritingFileJobs,
    formStepsValidity,
    setStepValidity,
    gstAnalysisJobs
  } = useContext(MonthlyReportFormContext);

  const [newUploadedDocIds, setNewUploadedDocIds] = useState<number[]>([]);
  const [deleteDocIds, setDeleteDocIds] = useState<number[]>([]);
  const [gstApiErrors, setGstApiErrors] = useState({});

  const sectionRef = useRef(null);
  const formRef = useRef(null);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const showError = searchParams.get('error');
    if (showError == "true") {
      formRef?.current?.submit();
      scrollToFirstError();
    }
  }, [searchParams])

  const scrollToFirstError = () => {
    try {

      const formState = formRef.current.getState();
      const { errors } = formState;
      // console.log('errors', errors);
      // console.log('form state', formState);
      // console.log('formState', formState)
      const firstErrorField = findFirstErrorField(errors);
      // console.log('firstErrorField', firstErrorField);
      const errorField = document.getElementById(firstErrorField) ?? document.querySelector(`[name="${firstErrorField}"]`);
      // console.log('errorField', errorField);
      // console.log('errorField.offset', errorField.offsetTop)
      if (errorField) {
        setTimeout(() => {
          errorField.scrollIntoView({ behavior: 'smooth' });
        }, 0)
        // console.log('sectionRootContainerRef', sectionRootContainerRef.current)
      }
    } catch (error) {
      console.log('error', error)
    }
  };

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      return new Promise((resolve) => {
        formRef.current.submit();
        if (!formStepsValidity[MonthlyReportSteps.gst]) {
          scrollToFirstError();
          resolve({ success: false, values: formRef?.current?.getState().values, pristine: formRef?.current?.getState().pristine, newDocIds: newUploadedDocIds, deleteDocIds: deleteDocIds })
        } else {
          resolve({ success: true, values: formRef?.current?.getState().values, pristine: formRef?.current?.getState().pristine, newDocIds: newUploadedDocIds, deleteDocIds: deleteDocIds })
        }
      })
    }
  }), [])

  useEffect(() => {
    sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <div className={styles.rootContainer}>
      <Form
        initialValues={formData}
        mutators={{
          ...arrayMutators,
          setFieldTouched: setFieldTouchedMutator,
        }}
        onSubmit={(values) => {
          return {}
        }}
        validate={(values) => {
          let errors = {};
          const { errors: gstErrors } = validateGstDetails(values, underwritingFileJobs, gstApiErrors, gstAnalysisJobs, ApplicationContextType.monthlyReport)
          errors = {
            ...errors,
            ...gstErrors
          }
          // console.log('gstErrors', gstErrors)
          return errors;
        }}
        render={({ values: formValues, handleSubmit, form }) => {
          formRef.current = form
          return (
            <form className={styles.formWrapper} onSubmit={handleSubmit}>
              <FormSpy subscription={{ valid: true, pristine: true }} onChange={(state) => {
                setFormPristine(state.pristine)
                setStepValidity(MonthlyReportSteps.gst, state.valid)
              }} />
              <div className={styles.formRootContainer}>
                <div className={styles.sectionContainer}>
                  <div className={styles.sectionTitleContainer}>
                    <div className={styles.sectionTitle}>
                      GST Details
                    </div>
                    <div className={styles.sectionSubTitle}>
                      Verify all your active GSTINs with an OTP.
                    </div>
                  </div>
                  <GstDetails
                    formCompleteStatus={formCompleteStatus}
                    newUploadedDocIds={newUploadedDocIds}
                    setNewUploadedDocIds={setNewUploadedDocIds}
                    deleteDocIds={deleteDocIds}
                    setDeleteDocIds={setDeleteDocIds}
                    gstApiErrors={gstApiErrors}
                    setGstApiErrors={setGstApiErrors}
                    formContext={MonthlyReportFormContext}
                    formType={formType}
                  />
                </div>
              </div>
            </form>
          )
        }}
      />
    </div >
  );
});

export default GST;